<script lang="ts">
  import { onMount } from "svelte"
  import Layout from "$app/Layouts/University.svelte"
  import GettingStarted from "./GettingStarted.svelte"
  import ManageGoals from "./ManageGoals.svelte"
  import PlatformFeatures from "./PlatformFeatures.svelte"
  import Recognitions from "./Recognitions.svelte"
  import PlanManagement from "./PlanManagement.svelte"
  import AccountManagement from "./AccountManagement.svelte"
  import { appStore } from "$app/store.svelte"

  type tabType = { title: string; active: boolean; component: any }
  let tabs = $state([
    { title: "Getting Started", active: true, component: GettingStarted },
    { title: "Goals", active: false, component: ManageGoals },
    { title: "Recognitions", active: false, component: Recognitions },
    { title: "Platform Features", active: false, component: PlatformFeatures },
    { title: "Plan Management", active: false, component: PlanManagement },
    { title: "Account Management", active: false, component: AccountManagement }
  ])

  let activeTabTitle = $state("")

  function updateTab(tab: tabType): void {
    const activeTab = tabs.find((t) => t.active === true)
    activeTab.active = false
    tab.active = true
    tabs = tabs
  }

  let props = $props()
  let plan = props.plan || null

  onMount(() => {
    activeTabTitle = tabs[0].title
    var hash = window.location.hash.substr(1)
    if (hash) {
      const tab = tabs.find((t) => t.title.replace(/\s+/g, "") === hash)
      if (tab) {
        updateTab(tab)
      }
    }
  })
</script>

<svelte:head>
  <script src="https://player.vimeo.com/api/player.js"></script>
</svelte:head>

<Layout {...props}>
  <div
    class="bg-gradient-to-r from-course-bg-light to-course-bg-dark w-full border-t-border-b-2 border-gray-800"
  >
    <div
      class="mx-auto max-w-7xl grid grid-cols-1 md:grid-cols-3 items-center sm:px-6 lg:px-8"
    >
      <div
        class="flex items-center justify-center md:justify-start mt-3 md:mt-0"
      >
        {#if plan}
          <img
            class="inline-block h-8 w-8 sm:h-12 sm:w-12 rounded-full shadow bg-gray-50 p-1"
            src={plan.logo_url}
            alt={plan.name}
          />
          <p
            class="text-lg md:text-3xl leading-tight text-gray-200 ml-2 mr-4"
            data-name="plan-name"
          >
            {plan.name}
          </p>
        {/if}
      </div>

      <div>
        <h1 class="text-white font-bold text-3xl text-center py-6">
          Resource Center
        </h1>
      </div>
      <div
        class="text-white flex items-center justify-center md:justify-end mb-3 md:mb-0"
      >
        {#if plan}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 19l-7-7 7-7"
            />
          </svg>
          <a href="/plans/{plan.id}" class="hover:border-b hover:text-blue-400"
            >Back to the One Page View</a
          >
        {/if}
      </div>
    </div>
  </div>

  <div
    class="relative bg-gray-50 pt-8 pb-20 px-4 sm:px-6 lg:pt-12 lg:pb-28 lg:px-8"
  >
    <div class="relative max-w-7xl mx-auto">
      <div class="text-center">
        <p class="mt-3 max-w-3xl mx-auto text-xl text-gray-600 sm:mt-4">
          Get quick tips in these bite-sized tutorial videos to help you and
          your team be successful in Lead With Purpose. Click the tabs to view
          the videos organized by their subject.
        </p>
      </div>

      <div class="mt-12 overflow-hidden">
        <div class="sm:hidden">
          <label for="tabs" class="sr-only">Select a tab</label>
          <select
            id="tabs"
            name="tabs"
            class="block w-full focus:ring-indigo-500 focus:border-indigo-500 border-gray-300 rounded-md"
            bind:value={activeTabTitle}
            onchange={() => {
              updateTab(tabs.find((t) => t.title === activeTabTitle))
            }}
          >
            {#each tabs as tab (tab.title)}
              <option>{tab.title}</option>
            {/each}
          </select>
        </div>
        <div class="bg-white hidden sm:block">
          <div class="border-b border-gray-200">
            <nav class="tabs -mb-px flex" aria-label="Tabs">
              {#each tabs as tab (tab.title)}
                <a
                  href="#{tab.title.replace(/\s/g, '')}"
                  class="tab w-1/3"
                  class:active={tab.active}
                  onclick={() => updateTab(tab)}
                >
                  {tab.title}
                </a>
              {/each}
            </nav>
          </div>
        </div>

        <div class="bg-white px-4 py-3 sm:p-6 mt-6 md:mt-0">
          {#each tabs as tab}
            <div
              data-tabs-target="panel"
              class="px-4 py-5 sm:p-6 bg-white"
              class:hidden={!tab.active}
            >
              <svelte:component this={tab.component} />
            </div>
          {/each}
        </div>
      </div>
    </div>
  </div>
</Layout>
